import { preferences } from './state'

let context: AudioContext | null = null

function audioContext() {
  context ||= new AudioContext()
  if (context.state === 'suspended') void context.resume()
  return context
}

export function playTone(kind: 'select' | 'next' | 'complete' = 'select') {
  if (!preferences.sound) return
  try {
    const ctx = audioContext()
    const now = ctx.currentTime
    const frequencies = kind === 'complete' ? [392, 494, 587] : kind === 'next' ? [330, 440] : [420]
    frequencies.forEach((frequency, index) => {
      const oscillator = ctx.createOscillator()
      const gain = ctx.createGain()
      oscillator.type = 'sine'
      oscillator.frequency.setValueAtTime(frequency, now + index * 0.07)
      gain.gain.setValueAtTime(0, now + index * 0.07)
      gain.gain.linearRampToValueAtTime(0.055, now + index * 0.07 + 0.012)
      gain.gain.exponentialRampToValueAtTime(0.001, now + index * 0.07 + 0.22)
      oscillator.connect(gain).connect(ctx.destination)
      oscillator.start(now + index * 0.07)
      oscillator.stop(now + index * 0.07 + 0.24)
    })
  } catch {
    // 浏览器拒绝音频上下文时保持静默，不影响答题。
  }
}
